import { get } from 'lodash'
import { CONFIGURATION_KEYS } from '../constants/enums'

export const isAssessorManagementEnabledForActivity = activity => {
  const valueMap = get(activity, 'configuration.valueMap')

  return valueMap && valueMap[CONFIGURATION_KEYS.isAssessorManagementEnabled.id] || false
}
